import Laudos from '@/modules/laudos/views/Laudos.vue';
import { beforeEnter } from '@/modules/laudos/locale';
const routes = [
    {
        path: '/laudo',
        redirect: 'dashboard',
        meta: {
            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
        },
        beforeEnter,
        component: Laudos,
        children: [
            {
                path: '',
                name: 'Laudos',
                meta: {
                    roles: [
                        'ROLE_FEATURE_MODULO_LAUDOS',
                        'ROLE_REGULAR',
                        'ROLE_OPERACAO_APROVADOR'
                    ]
                },
                component: () =>
                    import(
                        /* webpackChunkName: "laudos-inicio" */
                        '@/modules/laudos/views/avaliacaoSocioambiental/LaudoAvaliacaoSocioambiental.vue'
                    )
            },
            {
                path: 'dashboard',
                name: 'LaudosDashboard',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: () =>
                    import(
                        /* webpackChunkName: "laudos-dashboard" */
                        '@/modules/laudos/views/dashboard/LaudosDashboard.vue'
                    )
            },
            {
                path: 'bacen-fiscalizacao',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudosBacenFiscalizacao',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-laudos-bacen-fiscalizacao" */
                                '@/modules/laudos/views/bacenFiscalizacao/LaudoBacenFiscalizacao'
                            )
                    },
                    {
                        path: 'solicitacao',
                        name: 'LaudoSolicitacaoBacenFiscalizacao',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitacao" */
                                '@/modules/laudos/views/bacenFiscalizacao/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'benfeitorias',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudosBenfeitorias',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-laudos-benfeitorias" */
                                '@/modules/laudos/views/benfeitorias/LaudoBenfeitorias'
                            )
                    },
                    {
                        path: 'solicitacao',
                        name: 'LaudoSolicitacaoBenfeitorias',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-benfeitorias-solicitacao" */
                                '@/modules/laudos/views/benfeitorias/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'agricola',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudosAgricola',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-agricola" */
                                '@/modules/laudos/views/agricola/LaudoAgricola'
                            )
                    }
                ]
            },
            {
                path: 'conformidade-ambiental',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudosConformidadeAmbiental',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-conformidade-ambiental" */
                                '@/modules/laudos/views/conformidadeAmbiental/LaudoConformidadeAmbiental'
                            )
                    },
                    {
                        path: 'solicitacao/:territoriosIdsPesquisaInteligente?',
                        name: 'LaudoSolicitacaoConformidadeAmbiental',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitacao" */
                                '@/modules/laudos/views/conformidadeAmbiental/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'renovabio',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoRenovabio',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-renovabio" */
                                '@/modules/laudos/views/renovabio/LaudoRenovabio'
                            )
                    },
                    {
                        path: 'solicitacao/:territoriosIdsPesquisaInteligente?',
                        name: 'LaudoSolicitacaoRenovabio',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitar-laudo" */
                                '@/modules/laudos/views/renovabio/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'carbono',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoCarbono',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-carbono" */
                                '@/modules/laudos/views/carbono/LaudoCarbono'
                            )
                    }
                ]
            },
            {
                path: 'historico-agricola',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoHistoricoAgricola',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-historico-agricola" */
                                '@/modules/laudos/views/historicoAgricola/LaudoHistoricoAgricola'
                            )
                    }
                ]
            },
            {
                path: 'relatorio-territorial',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoRelatorioTerritorial',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-relatorio-territorial" */
                                '@/modules/laudos/views/relatorioTerritorial/LaudoRelatorioTerritorial'
                            )
                    }
                ]
            },
            {
                path: 'analise-cobertura-solo',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoAnaliseCoberturaSolo',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-analise-cobertura-solo" */
                                '@/modules/laudos/views/analiseCoberturaSolo/LaudoAnaliseCoberturaSolo'
                            )
                    }
                ]
            },
            {
                path: 'diagnostico-agricola',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoDiagnosticoAgricola',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-diagnostico-agricola" */
                                '@/modules/laudos/views/diagnosticoAgricola/LaudoDiagnosticoAgricola'
                            )
                    }
                ]
            },
            {
                path: 'supressao-vegetal',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoSupressaoVegetal',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-supressao-vegetal" */
                                '@/modules/laudos/views/supressaoVegetal/LaudoSupressaoVegetal'
                            )
                    }
                ]
            },
            {
                path: 'supressao-vegetal-red-yellow-flag',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoSupressaoVegetalRedYellowFlag',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "supressao-vegetal-red-yellow-flag" */
                                '@/modules/laudos/views/supressaoVegetalRedYellowFlag/LaudoSupressaoVegetalRedYellowFlag.vue'
                            )
                    }
                ]
            },
            {
                path: 'tecnico-agricola',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoTecnicoAgricola',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-tecnico-agricola" */
                                '@/modules/laudos/views/tecnicoAgricola/LaudoTecnicoAgricola'
                            )
                    },
                    {
                        path: 'solicitacao',
                        name: 'LaudoSolicitacaoTecnicoAgricola',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitar-laudo-tecnico-agricola" */
                                '@/modules/laudos/views/tecnicoAgricola/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'croqui',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoCroqui',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-croqui" */
                                '@/modules/laudos/views/croqui/LaudoCroqui'
                            )
                    },
                    {
                        path: 'solicitacao',
                        name: 'LaudoSolicitacaoCroqui',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitar-laudo-croqui" */
                                '@/modules/laudos/views/croqui/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'bacen-resolucao-140',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoBacenResolucao140',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-bacen-resolucao-140" */
                                '@/modules/laudos/views/bacenResolucao140/LaudoBacenResolucao'
                            )
                    },
                    {
                        path: 'solicitacao',
                        name: 'LaudoSolicitacaoBacenResolucao140',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitacao-bacen-resolucao-140" */
                                '@/modules/laudos/views/bacenResolucao140/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'avaliacao-fundiaria',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoAvaliacaoFundiarias',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-avaliacao-fundiarias" */
                                '@/modules/laudos/views/avaliacaoFundiaria/LaudoAvaliacaoFundiarias'
                            )
                    },
                    {
                        path: 'solicitacao',
                        name: 'LaudoSolicitacaoAvaliacaoFundiarias',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-solicitacao-avaliacao-fundiarias" */
                                '@/modules/laudos/views/avaliacaoFundiaria/SolicitarLaudo'
                            )
                    }
                ]
            },
            {
                path: 'avaliacao-area-produtiva',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoAvaliacaoAreaProdutiva',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-avaliacao-area-produtiva" */
                                '@/modules/laudos/views/avaliacaoAreaProdutiva/LaudoAvaliacaoAreaProdutiva'
                            )
                    }
                ]
            },
            {
                path: 'avaliacao-socioambiental',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoAvaliacaoSocioambiental',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-avaliacao-socioambiental" */
                                '@/modules/laudos/views/avaliacaoSocioambiental/LaudoAvaliacaoSocioambiental'
                            )
                    }
                ]
            },
            {
                path: 'parceria-sustentavel-rastreabilidade',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'parceriaSustentavelRastreabilidade',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "parceria-sustentavel-rastreabilidade" */
                                '@/modules/laudos/views/parceriaSustentavelRastreabilidade/LaudoParceriaSustentavelRastreabilidade.vue'
                            )
                    }
                ]
            },
            {
                path: 'dinamica-exploracao',
                meta: {
                    roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                },
                component: Laudos,
                children: [
                    {
                        path: '',
                        name: 'LaudoDinamicaExploracao',
                        meta: {
                            roles: ['ROLE_FEATURE_MODULO_LAUDOS']
                        },
                        component: () =>
                            import(
                                /* webpackChunkName: "laudos-dinamica-exploracao" */
                                '@/modules/laudos/views/dinamicaExploracao/LaudoDinamicaExploracao.vue'
                            )
                    }
                ]
            }
        ]
    }
];

export default routes;
